import { IS_BROWSER, appPrefixedHost } from "@smartrr/shared/constants";
import { IVendorUser } from "@smartrr/shared/entities/VendorUser";

import { getShopUrlFromGlobals } from "./getShopUrlFromGlobals";
import { redirectToShopifyAuth } from "./redirectToShopifyAuth";
import { vendorPortalFrontendRedirect } from "../vendorPortalFrontendRedirect";
import { useEffect, useState } from "react";

/**
 * used in admin auth container. returns true if redirecting
 */
export function useRequiredAuthRedirects(userIsLoading: boolean, user: IVendorUser | null): boolean {
  const [isRedirecting, setIsRedirecting] = useState(false);
  const shopUrl = getShopUrlFromGlobals();

  useEffect(() => {
    if (!userIsLoading && !user) {
      // redirect to shopify app for authentication if unauthenticated
      doAuthenticationRedirect(shopUrl);
      setIsRedirecting(true);
    }
  }, [userIsLoading, user]);

  return isRedirecting;
}

/**
 * redirects to either the current shop's shopify auth or the Smartrr login
 * screen (if no current shop)
 */
function doAuthenticationRedirect(shopUrl?: string): void {
  if (!IS_BROWSER) {
    return;
  }

  if (shopUrl) {
    return redirectToShopifyAuth(shopUrl);
  }

  return vendorPortalFrontendRedirect(`https://${appPrefixedHost}/login`);
}
